import Icon from '../components/Icon.vue'

Icon.register({
  'paper-plane': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M476 3.2L12.5 270.6C-5.6 281-3.3 306.2 14.7 313.8L121 358.4 408.3 105.2C413.8 100.3 421.6 107.8 416.9 113.5L176 407V487.5C176 511.1 204.5 520.4 218.5 503.3L282 426 406.6 478.2C420.8 484.2 437 475.3 439.6 460L511.6 28C515 7.8 493.3-6.8 476 3.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/paper-plane.js
// module id = vrdY
// module chunks = 144